import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import socialList from './social-list';
var commonAttributes = {
  category: 'widgets',
  parent: ['core/social-links'],
  supports: {
    reusable: false,
    html: false
  },
  edit: edit
}; // Create individual blocks out of each site in social-list.js

export var sites = Object.keys(socialList).map(function (site) {
  var siteParams = socialList[site];
  return {
    name: 'core/social-link-' + site,
    settings: _objectSpread({
      title: siteParams.name,
      icon: siteParams.icon,
      description: __('Link to ' + siteParams.name)
    }, commonAttributes, {
      attributes: {
        url: {
          type: 'string'
        },
        site: {
          type: 'string',
          default: site
        }
      }
    })
  };
});
//# sourceMappingURL=index.js.map